module.exports = __webpack_public_path__ + "img/mi ombre.23a8fa51.png";